window.addEventListener('load', () => {
  let isDesktop = window.matchMedia('(min-width: 1024px)').matches;

  /**
   * Remove padding on grid items
   */
  const formatGridItems = () => {
    // Handle title padding left in JS because it's not possible in CSS
    document.querySelectorAll('.js-grid-item').forEach((item, index) => {
      if (item.getBoundingClientRect().left > 0) {
        item.classList.add('js-not-first-in-row');
      } else {
        item.classList.remove('js-not-first-in-row');
      }
    });
  };

  // Call formatGridItems on load, on resize if we change from mobile to desktop and vice versa
  formatGridItems();

  window.addEventListener('resize', () => {
    const isDesktopNow = window.matchMedia('(min-width: 1024px)').matches;

    if (isDesktop !== isDesktopNow) {
      isDesktop = isDesktopNow;
      formatGridItems();
    }
  });

  // Make formatGridItems globally available for the Load More pagination
  window.formatGridItems = formatGridItems;
});
